
export const WHOLESALER_PRODUCT_ADD_REQUEST = "WHOLESALER_PRODUCT_ADD_REQUEST";
export const WHOLESALER_PRODUCT_ADD_SUCCESS = "WHOLESALER_PRODUCT_ADD_SUCCESS";
export const WHOLESALER_PRODUCT_ADD_FAILURE = "WHOLESALER_PRODUCT_ADD_FAILURE";

export const WHOLESALER_PRODUCT_EDIT_REQUEST = "WHOLESALER_PRODUCT_EDIT_REQUEST";
export const WHOLESALER_PRODUCT_EDIT_SUCCESS = "WHOLESALER_PRODUCT_EDIT_SUCCESS";
export const WHOLESALER_PRODUCT_EDIT_FAILURE = "WHOLESALER_PRODUCT_EDIT_FAILURE";

export const WHOLESALER_PRODUCT_VIEW_REQUEST = "WHOLESALER_PRODUCT_VIEW_REQUEST";
export const WHOLESALER_PRODUCT_VIEW_SUCCESS = "WHOLESALER_PRODUCT_VIEW_SUCCESS";
export const WHOLESALER_PRODUCT_VIEW_FAILURE = "WHOLESALER_PRODUCT_VIEW_FAILURE";

export const WHOLESALER_PRODUCT_VIEW_ALL_REQUEST = "WHOLESALER_PRODUCT_VIEW_ALL_REQUEST";
export const WHOLESALER_PRODUCT_VIEW_ALL_SUCCESS = "WHOLESALER_PRODUCT_VIEW_ALL_SUCCESS";
export const WHOLESALER_PRODUCT_VIEW_ALL_FAILURE = "WHOLESALER_PRODUCT_VIEW_ALL_FAILURE";

export const WHOLESALER_PRODUCT_DELETE_REQUEST = "WHOLESALER_PRODUCT_DELETE_REQUEST";
export const WHOLESALER_PRODUCT_DELETE_SUCCESS = "WHOLESALER_PRODUCT_DELETE_SUCCESS";
export const WHOLESALER_PRODUCT_DELETE_FAILURE = "WHOLESALER_PRODUCT_DELETE_FAILURE";

export const WHOLESALER_PRODUCT_SEARCH_REQUEST = "WHOLESALER_PRODUCT_SEARCH_REQUEST";
export const WHOLESALER_PRODUCT_SEARCH_SUCCESS = "WHOLESALER_PRODUCT_SEARCH_SUCCESS";
export const WHOLESALER_PRODUCT_SEARCH_FAILURE = "WHOLESALER_PRODUCT_SEARCH_FAILURE";

export const WHOLESALER_PRODUCT_VIEW_WHOLESALERID_REQUEST = "WHOLESALER_PRODUCT_VIEW_WHOLESALERID_REQUEST";
export const WHOLESALER_PRODUCT_VIEW_WHOLESALERID_SUCCESS = "WHOLESALER_PRODUCT_VIEW_WHOLESALERID_SUCCESS";
export const WHOLESALER_PRODUCT_VIEW_WHOLESALERID_FAILURE = "WHOLESALER_PRODUCT_VIEW_WHOLESALERID_FAILURE";

export const WHOLESALER_PRODUCT_VIEW_WHOLESALERID_SEARCH_REQUEST = "WHOLESALER_PRODUCT_VIEW_WHOLESALERID_SEARCH_REQUEST";
export const WHOLESALER_PRODUCT_VIEW_WHOLESALERID_SEARCH_SUCCESS = "WHOLESALER_PRODUCT_VIEW_WHOLESALERID_SEARCH_SUCCESS";
export const WHOLESALER_PRODUCT_VIEW_WHOLESALERID_SEARCH_FAILURE = "WHOLESALER_PRODUCT_VIEW_WHOLESALERID_SEARCH_FAILURE";

export const WHOLESALER_PRODUCT_RESET_STATE = "WHOLESALER_PRODUCT_RESET_STATE";
